/**
 * Manually mapped from:
 * "RIB ALLOTMENT PROPOSAL RATES FOR HOTELS RIVER 2026" — Royal & Imperial Belvedere Resort.
 */
const SEASON_PRICES = {
  A: [53, 104, 57, 59, 63, 68, 162, 196, 228, 236, 261, 128, 141],
  B: [55, 109, 59, 62, 67, 75, 183, 205, 253, 264, 289, 134, 147],
  C: [76, 148, 82, 85, 93, 104, 241, 289, 324, 344, 392, 185, 201],
  D: [91, 185, 102, 106, 116, 128, 282, 336, 390, 401, 438, 222, 246],
  E: [109, 214, 119, 122, 131, 144, 369, 380, 418, 437, 483, 268, 287],
  F: [120, 235, 131, 135, 144, 158, 406, 418, 474, 495, 557, 303, 318],
  G: [109, 220, 119, 126, 135, 148, 369, 380, 418, 437, 483, 268, 287],
  H: [91, 185, 102, 106, 116, 128, 282, 336, 390, 408, 438, 218, 241],
  I: [76, 148, 82, 85, 93, 104, 241, 289, 324, 344, 392, 185, 201],
  J: [54, 109, 60, 63, 70, 77, 173, 200, 240, 239, 265, 131, 143],
};

function room(
  index,
  code,
  id,
  name,
  nameHe,
  chargeType,
  allotment,
  minAdults,
  maxAdults,
  maxChildren,
  minOccupancy,
  maxOccupancy,
  infantsAllowed,
  occupancyLabel,
) {
  const prices = {};
  Object.keys(SEASON_PRICES).forEach((season) => {
    prices[season] = SEASON_PRICES[season][index];
  });
  return {
    code,
    id,
    name,
    nameHe,
    board: "AI",
    chargeType,
    allotment,
    minAdults,
    maxAdults,
    maxChildren,
    minOccupancy,
    maxOccupancy,
    infantsAllowed,
    occupancyLabel,
    seasonalPrices: prices,
  };
}

export const belvedereContract = {
  hotelCode: "royal-belvedere-2026",
  hotelName: "Royal & Imperial Belvedere Resort",
  hotelNameHe: "Royal & Imperial Belvedere Resort",
  location: "Hersonissos, Crete",
  locationHe: "חרסוניסוס, כרתים",
  starRating: 4,
  kosher: false,
  trustBeachBadgeHe: "בקרבת החוף · בריכות",
  board: "All Inclusive",
  boardHe: "הכל כלול",
  seasonLabel: "Summer 2026",
  currency: "EUR",
  /** SSOT public: +30% list, 10% sale discount label, 20% effective on net. */
  publicListMarkupPercent: 30,
  publicEffectiveMarkupTargetPercent: 20,
  publicSaleDiscountPercent: 10,
  /** SSOT agent: +10% on hotel net. */
  agentMarkupPercent: 10,
  /** @deprecated Tiered markup replaced by flat public/agent rates — kept for reference. */
  defaultMarkupPercent: 25,
  highNetMarkupThresholdEur: 1500,
  highNetMarkupPercent: 20,
  minStayNights: 3,
  releaseNights: 1,
  accommodationTaxPerRoomPerNight: 10,
  seasons: [
    { code: "A", from: "2026-04-01", to: "2026-05-11", minStayNights: 3, releaseNights: 1 },
    { code: "B", from: "2026-05-12", to: "2026-05-26", minStayNights: 3, releaseNights: 3 },
    { code: "C", from: "2026-05-27", to: "2026-06-19", minStayNights: 3, releaseNights: 1 },
    { code: "D", from: "2026-06-20", to: "2026-07-01", minStayNights: 3, releaseNights: 1 },
    { code: "E", from: "2026-07-02", to: "2026-07-17", minStayNights: 3, releaseNights: 1 },
    { code: "F", from: "2026-07-18", to: "2026-08-25", minStayNights: 3, releaseNights: 1 },
    { code: "G", from: "2026-08-26", to: "2026-09-15", minStayNights: 3, releaseNights: 1 },
    { code: "H", from: "2026-09-16", to: "2026-09-27", minStayNights: 3, releaseNights: 1 },
    { code: "I", from: "2026-09-28", to: "2026-10-15", minStayNights: 3, releaseNights: 1 },
    { code: "J", from: "2026-10-16", to: "2026-11-05", minStayNights: 3, releaseNights: 1 },
  ],
  roomTypes: [
    room(0, 1, "promo-economy", "Promo Room - Economy Room", "חדר פרומו / אקונומי", "per_person", 1, 2, 2, 0, 2, 2, false, "2 מבוגרים"),
    room(1, 2, "superior-garden-single", "Superior Garden or Mountain View (Single)", "סופיריור נוף גן / הר (יחיד)", "per_unit", 1, 1, 1, 0, 1, 1, false, "מבוגר יחיד"),
    room(2, 3, "sea-view", "Sea View Room", "חדר נוף לים", "per_person", 1, 2, 2, 0, 2, 2, false, "2 מבוגרים"),
    room(3, 4, "superior-land", "Superior Land View", "סופיריור נוף יבשה", "per_person", 5, 2, 3, 1, 2, 3, true, "2–3 מבוגרים"),
    room(4, 5, "superior-sea", "Superior Sea View", "סופיריור נוף לים", "per_person", 5, 2, 3, 1, 2, 3, true, "2–3 מבוגרים"),
    room(5, 6, "superior-sea-high", "Superior Sea View High Floor", "סופיריור נוף לים קומה גבוהה", "per_person", 5, 2, 3, 1, 2, 3, true, "2–3 מבוגרים"),
    room(6, 7, "family-economy-4", "Economy Family Land View 4 pax", "משפחתי אקונומי נוף יבשה 4 אורחים", "per_unit", 2, 2, 2, 2, 2, 4, true, "2 מבוגרים + עד 2 ילדים"),
    room(7, 8, "family-economy-5", "Economy Family Land View 5 pax", "משפחתי אקונומי נוף יבשה 5 אורחים", "per_unit", 5, 2, 5, 3, 4, 5, true, "עד 5 אורחים"),
    room(8, 9, "family-superior-land-4", "Family Superior Land View 4 pax", "משפחתי סופיריור נוף יבשה 4 אורחים", "per_unit", 3, 2, 4, 2, 2, 4, true, "עד 4 אורחים"),
    room(9, 10, "family-superior-sea-4", "Family Superior Sea View 4 pax", "משפחתי סופיריור נוף לים 4 אורחים", "per_unit", 3, 2, 4, 2, 2, 4, true, "עד 4 אורחים"),
    room(10, 12, "family-superior-land-5", "Family Superior Land View 5 pax", "משפחתי סופיריור נוף יבשה 5 אורחים", "per_unit", 3, 2, 5, 3, 3, 5, true, "עד 5 אורחים"),
    room(11, 13, "suite-whirlpool-4", "Suite with Outdoor Whirlpool Land View 4 pax", "סוויטה עם ג'קוזי חיצוני נוף יבשה 4 אורחים", "per_person", 2, 2, 4, 2, 2, 4, true, "עד 4 אורחים בתשלום"),
    room(12, 14, "suite-whirlpool-5", "Suite with Outdoor Whirlpool Land View 5 pax", "סוויטה עם ג'קוזי חיצוני נוף יבשה 5 אורחים", "per_person", 2, 2, 5, 3, 3, 5, true, "עד 5 אורחים בתשלום"),
  ],
  remarks: [
    "תינוקות (0–1.99) אינם מורשים בחדרים 1, 2, 3.",
    "תינוקות אינם מורשים מעבר לתפוסה מקסימלית בחדרים 4, 5, 6.",
    "מס עירייה: 10€ לחדר ללילה — משולם ישירות במלון.",
    "שינוי שם אורח ראשי אינו מתקבל.",
  ],
  cancellationPolicy: [
    "ביטול 14–1 ימים לפני הגעה: ללא חיוב",
    "ביטול 2–6 ימים לפני הגעה: לפי תנאי החוזה",
    "יום לפני הגעה / No Show: 100%",
    "יציאה מוקדמת: 100%",
  ],
  paymentPolicy: "תשלום מקדמה שבוע לפני ההגעה",
  disclaimerHe: "המחיר כפוף לאישור זמינות סופי מול המלון",
};

/**
 * Family unit rooms (7,8,9,10,12): מחיר unit ללילה — ילד לא משנה את מחיר היחידה בתוך תפוסה מותרת.
 * Badge "ילד ראשון חינם" = הילד לא מוסיף מעל מחיר ה-unit (בניגוד לחדרי pp 4–6).
 */
export const BELVEDERE_FIRST_CHILD_FREE_ROOM_CODES = [7, 8, 9, 10, 12];

/** Marketing badge on hotel-only room cards — free cancellation window before arrival. */
export const BELVEDERE_FREE_CANCELLATION_BADGE_HE = "ביטול ללא עלות עד 7 ימים להגעה";

export const BELVEDERE_SEASON_CODES = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
